import { useState } from "react";
import { KeyRound } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { resetLaunchMode } from "@/hooks/useLaunchMode";

/** "Have an invite code?" — lets early testers past the coming-soon splash. */
export default function InviteCodeForm() {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/launch/unlock", { code });
      resetLaunchMode();
      window.location.assign("/register?welcome=early"); // cookie now set — full site opens
    } catch (err) {
      setError(formatApiError(err));
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="invite-code-toggle"
        className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#f7f5f0]/60 hover:text-[#f7f5f0] underline underline-offset-4 flex items-center gap-1.5"
      >
        <KeyRound className="w-3 h-3" strokeWidth={1.75} /> Have an invite code?
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-wrap items-center gap-3" data-testid="invite-code-form">
      <label className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#f7f5f0]/70 flex items-center gap-1.5" htmlFor="invite-code">
        <KeyRound className="w-3 h-3" strokeWidth={1.75} /> Invite code
      </label>
      <input
        id="invite-code"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        placeholder="PINS-XXXXXX"
        required
        autoFocus
        className="bg-transparent border border-[#f7f5f0]/40 focus:border-[#f7f5f0] outline-none px-3 py-1.5 font-mono text-xs uppercase tracking-[0.2em] text-[#f7f5f0] placeholder:text-[#f7f5f0]/30 w-44"
        data-testid="invite-code-input"
      />
      <button
        type="submit"
        disabled={busy}
        className="border border-[#f7f5f0] px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] hover:bg-[#f7f5f0] hover:text-[#1f1f1f] transition-colors disabled:opacity-50"
        data-testid="invite-code-submit"
      >
        {busy ? "Checking…" : "Enter"}
      </button>
      {error && <p className="w-full sm:w-auto font-mono text-[10px] text-[#e8a08f]" data-testid="invite-code-error">{error}</p>}
    </form>
  );
}
